import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="container-editorial py-32 text-center">
      <div className="eyebrow mb-4">Erreur 404</div>
      <h1 className="font-display text-5xl md:text-6xl mb-6">Page introuvable</h1>
      <p className="text-anthracite/60 max-w-md mx-auto mb-10">
        La page que vous cherchez n'existe pas ou a été déplacée.
      </p>
      <Link
        to="/"
        className="inline-flex items-center bg-terracotta hover:bg-copper text-white px-6 py-3 text-sm tracking-wide transition-colors"
        data-testid="notfound-home-link"
      >
        Retour à l'accueil
      </Link>
    </section>
  );
}
